import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { BaseComponent } from '../../../../../../models/base/base-component';
import { EditTemplateProductMenuViewModel } from '../edit-template-product-menu-view-model';
import { ViewModelConnector } from '@mobilefirstdev/base-angular';

@Component({
  selector: 'app-edit-template-product-menu-footer',
  templateUrl: './edit-template-product-menu-footer.component.html',
  styleUrls: [
    './edit-template-product-menu-footer.component.scss',
    '../../../../../shared/styles/edit-page-styles.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class EditTemplateProductMenuFooterComponent extends BaseComponent {
  constructor(public viewModel: EditTemplateProductMenuViewModel) {
    super();
  }

  @Input() @ViewModelConnector('connectToFormAutoSubmitted') formAutoSubmitted: any[];
  @Input() formErrorMessages: { [label: string]: string } | null | undefined;
  @Input() formDisableSubmit: boolean = true;
  @Input() formHasErrors: boolean = true;
  @Input() formPristine: boolean = true;
  @Output() submitForms = new EventEmitter<boolean>(true);
}
